import React from 'react'
import styled from 'styled-components'
import { Block, ButtonGroup, Button } from '@mote/ui'
import { Content } from '../Dashboard/components'
import { ImportCSVButton } from './/import-csv/importCSVButton'
import { AccountAddUsers } from './AccountAddUsers'
import { AccountUsersManagement } from './AccountUsersManagement'
import { AccountUserDomains } from './AccountUserDomains'

export const AccountUsers = ({ account, onAccountUpdated }) => {
  const [showAddUsersPanel, setShowAddUsersPanel] = React.useState(false)
  const [successMessage, setSuccessMessage] = React.useState(null)

  function openAddUsersSection() {
    setShowAddUsersPanel(true)
    setSuccessMessage(null)
  }

  function closeAddUsersSection() {
    setShowAddUsersPanel(false)
  }

  const handleSuccess = React.useCallback(message => {
    setSuccessMessage(message)
    closeAddUsersSection()
  }, [])

  return (
    <>
      {(account.enableFallbackUnlimitedDomain ||
        account.enableForcedMinorUnlimitedDomain ||
        account.enableForcedMinorEssentialDomain) && (
        <>
          <AccountUserDomains
            account={account}
            onAccountUpdated={onAccountUpdated}
          />
          <Divider />
        </>
      )}

      <Content
        type='section'
        title='Users directory'
        subtitle={`You have assigned ${account.totalUsedSeats} of ${account.totalPaidSeats} available licenses`}
        noPadding
      >
        <ButtonGroup buttonGap={20}>
          <ImportCSVButton />
          {!showAddUsersPanel && (
            <Button
              text='Add users now'
              variant='primary'
              onClick={openAddUsersSection}
            />
          )}
        </ButtonGroup>

        {showAddUsersPanel && (
          <>
            <Divider style={{ margin: '12px 0' }} />
            <AccountAddUsers
              account={account}
              onAccountUpdated={onAccountUpdated}
              onCancel={closeAddUsersSection}
              onSuccess={handleSuccess}
              fulfilledSeats={account.totalUsedSeats === account.totalPaidSeats}
            />
          </>
        )}

        {successMessage && <Block>{successMessage}</Block>}

        <AccountUsersManagement
          account={account}
          onAccountUpdated={onAccountUpdated}
        />
      </Content>
    </>
  )
}

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: #ececf3;
  margin: 40px 0;
`
